import(/* webpackMode: "eager" */ "/vercel/path0/apps/web-app/src/app/[locale]/not-found.tsx");
